import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { TripRoutesForm } from "./TripRoutes";
import { PluggablePatchList } from "./Patches";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export const Trips = (props) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs value={value} onChange={handleChange} aria-label="routes tabs" centered>
        <Tab label="Trip Routes (Beta)" id="tab-trip-routes" aria-controls="tabpanel-0" />
        <Tab label="Patches" id="tab-patches" aria-controls="tabpanel-1" />
      </Tabs>
      <TabPanel value={value} index={0}>
        <TripRoutesForm />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <PluggablePatchList />
      </TabPanel>
    </Box>
  );
};
